"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
module.exports = function prettierBytes(num) {
  if (typeof num !== 'number' || Number.isNaN(num)) {
    throw new TypeError("Expected a number, got ".concat(_typeof(num)));
  }
  var neg = num < 0;
  var units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  if (neg) {
    num = -num;
  }
  if (num < 1) {
    return "".concat((neg ? '-' : '') + num, " B");
  }
  var exponent = Math.min(Math.floor(Math.log(num) / Math.log(1024)), units.length - 1);
  num = Number(num / Math.pow(1024, exponent));
  var unit = units[exponent];
  if (num >= 10 || num % 1 === 0) {
    return "".concat((neg ? '-' : '') + num.toFixed(0), " ").concat(unit);
  }
  return "".concat((neg ? '-' : '') + num.toFixed(1), " ").concat(unit);
};